export default "__VITE_ASSET__DW$5ISyq__"